export enum GAEventName {
  Demo = 'demo',
  SignupPageView = 'signup_page_view',
  SignupFormStart = 'signup_form_start',
  SignupMethodClick = 'signup_method_click',
  SignupFormSubmit = 'signup_form_submit',
  SignupSsoReturn = 'signup_sso_return',
  AccountCreated = 'account_created',
  Trial = 'trial',
}
